export const NoticeImages = ({notice})=>{
    
    return notice.data?.files.map((file, key)=>{
        if(file.url===null)return null;
        if(file.mime==='image/gif' || file.mime==='image/png' || file.mime==='image/jpeg' ) {
            if(file.mainYn==='Y')return null;
            return (
                <img className="attachImage image img-thumbnail" src={file.url} alt={`${file.originalName} 첨부사진`} key={file.id} />
            );
        }
        return null;
    });//end map 
};